export default __webpack_public_path__ + "static/zoho-860645a073cec195158365c47c710f29.png";